export default "/images/framework/ShopLink.d5fe58bb.svg?d5fe58bb";